import { render, staticRenderFns } from "./verticalItem.vue?vue&type=template&id=dc73255c&"
import script from "./verticalItem.vue?vue&type=script&lang=js&"
export * from "./verticalItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports